import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MdSearch, MdVisibility } from "react-icons/md";
import { getTransactionListRequest } from "../../redux/actions/transactionActions";
import Pagination from "../../helper/Pagination";
import TransactionOffcanvas from "../../helper/TransactionOffcanvas";
import "../../styles/InputSheet.css";
import { FaSearch } from "react-icons/fa";

const Transaction = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const { loading, transactions, totalCount, error } = useSelector(
    (state) =>
      state?.transaction || {
        loading: false,
        transactions: [],
        totalCount: 0,
        error: null,
      }
  );
  const oemId = user?.oemPartner?.id;
  const getCurrencySymbol = (currency) => {
    const symbols = {
      USD: "$",
      JPY: "¥",
      EUR: "€",
      GBP: "£",
      SGD: "S$",
      HKD: "HK$",
      AUD: "A$",
    };
    return symbols[currency?.toUpperCase()] || "$";
  };
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(20);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  useEffect(() => {
    if (oemId) {
      dispatch(getTransactionListRequest({ oemId, search, page, limit }));
    }
  }, [dispatch, oemId, search, page, limit]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleViewTransaction = (transaction) => {
    setSelectedTransaction(transaction);
    setShowOffcanvas(true);
  };

  const handleCloseOffcanvas = () => {
    setShowOffcanvas(false);
    setSelectedTransaction(null);
  };

  if (loading && transactions?.length === 0) {
    return (
      <div className="page-container">
        <div className="page-card scroll-container">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                border: "4px solid #f3f3f3",
                borderTop: "4px solid #667eea",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                marginBottom: "20px",
              }}
            ></div>
            <p style={{ color: "#7f8c8d", fontSize: "16px" }}>
              Loading transactions...
            </p>
            <style>
              {`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}
            </style>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div
          className="mt-2 d-flex align-items-end justify-content-between"
          style={{ padding: "0 20px" }}
        >
          <div>
            <p style={{ color: "black", margin: "5px 0 0 0" }}>
              Total Transactions: {totalCount}
            </p>
          </div>
          {/* Search Bar */}
          <div className="position-relative d-flex justify-content-end">
            <input
              type="search"
              placeholder="Search scans...."
              className="form-input"
              value={search}
              onChange={handleSearch}
              style={{ width: "220px" }}
            />
            {search === "" && (
              <div
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "13px",
                  transform: "translateY(-50%)",
                  color: "#666",
                }}
              >
                <FaSearch />
              </div>
            )}
          </div>
        </div>

        {/* Transaction Table */}
        <div className="input-form-section">
          <div className="table-scroll-wrapper">
            <table className="partners-table">
              <thead>
                <tr>
                  <th>Sr No.</th>
                  <th>Name</th>
                  <th>Plan Name</th>
                  <th>Amount</th>
                  <th>Currency</th>
                  <th>Coupon</th>
                  <th>Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#666",
                      }}
                    >
                      <div className="loading-spinner"></div>
                    </td>
                  </tr>
                ) : transactions?.length === 0 ? (
                  <tr>
                    <td
                      colSpan="8"
                      style={{
                        textAlign: "center",
                        padding: "20px",
                        color: "#666",
                      }}
                    >
                      No transactions found
                    </td>
                  </tr>
                ) : (
                  (transactions || [])
                    .filter((transaction) => transaction && transaction._id)
                    .map((transaction, index) => (
                      <tr key={transaction._id}>
                        <td>{(page - 1) * limit + index + 1}</td>
                        <td>
                          {`${transaction?.user?.firstName || ""} ${
                            transaction?.user?.lastName || ""
                          }`.trim() || "N/A"}
                        </td>
                        <td>{transaction?.plan?.name || "N/A"}</td>
                        <td>
                          {getCurrencySymbol(
                            transaction?.currency || transaction?.plan?.currency
                          )}
                          {transaction?.amount}
                        </td>
                        {/* <td>
                            <span className={`status-badge ${transaction.status?.toLowerCase() || 'pending'}`}>
                              {transaction.status || 'Pending'}
                            </span>
                          </td> */}
                          <td>{(transaction?.currency || transaction?.plan?.currency)?.toUpperCase()}</td>
                          <td>{transaction?.couponApplied === true  ? "Yes" : "No"}</td>
                        <td>
                          {new Date(transaction.paidAt).toLocaleDateString()}
                        </td>
                        <td>
                          <div className="row-actions">
                            <MdVisibility
                              onClick={() => handleViewTransaction(transaction)}
                              className="info_pointer fs-5"
                              title="View Details"
                            />
                          </div>
                        </td>
                      </tr>
                    ))
                )}
              </tbody>
            </table>
          </div>

          <Pagination
            currentPage={page}
            totalPages={Math.ceil((totalCount || 0) / limit)}
            totalItems={totalCount || 0}
            itemsPerPage={limit}
            onPageChange={setPage}
          />
        </div>

        <TransactionOffcanvas
          show={showOffcanvas}
          onClose={handleCloseOffcanvas}
          transaction={selectedTransaction}
        />
      </div>
    </div>
  );
};

export default Transaction;
